import { matchPath, useLocation } from "react-router-dom";
import { Compass } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { runTour } from "@/components/app/tour";
import { PAGE_TOURS } from "@/tours/pageTours";

const visible = (sel) => {
  const el = document.querySelector(sel);
  return el && el.getClientRects().length > 0;
};

export function PageTour({ className }) {
  const { pathname } = useLocation();
  const entry = PAGE_TOURS.find(([p]) => matchPath({ path: p, end: true }, pathname));
  if (!entry) return null;
  const start = () => {
    const steps = entry[1].filter((x) => visible(x.el)).map((x) => ({ element: x.el, popover: { title: x.title, description: x.text } }));
    if (!steps.length) return toast.info("Nothing to show on this page yet.");
    runTour(steps);
  };
  return (
    <Button variant="ghost" size="sm" onClick={start} className={className} aria-label="Take a tour of this page" data-testid="page-tour-btn">
      <Compass size={15} aria-hidden="true" /> Tour
    </Button>
  );
}
